<div class="modal-header">
  <div class="modelHeading">
    <h6 class="modalTitle">Change Password</h6>
    <p>Kindly input your current and new password below to complete the update</p>
  </div>
  <button type="button" class="btnClose" (click)="onClose();"></button>
</div>
<div class="modal-body">
  <form [formGroup]="changePasswordFrom" (ngSubmit)="onChangePassword()">
    <div class="form-group">
      <label>Old Password*</label>
      <div class="pwdWrap">
        <input [type]="isOldPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Old password"
          formControlName="oldPassword" name="oldPassword">
        <a href="javascript:void(0)" (click)="isOldPasswordVisible = !isOldPasswordVisible;" class="input-group-text">
          <i [ngClass]="{'zmdi-eye':isOldPasswordVisible, 'zmdi-eye-off':!isOldPasswordVisible}" class="zmdi"
            aria-hidden="true"></i>
        </a>
      </div>
      <div class="invalid-feedback"
        *ngIf="changePasswordFrom.controls['oldPassword'].hasError('required') && showError">
        *Please enter old password.
      </div>
    </div>
    <div class="form-group">
      <label>New Password*</label>
      <div class="pwdWrap">
        <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Add new password"
          formControlName="password" name="password">
        <a href="javascript:void(0)" (click)="isPasswordVisible = !isPasswordVisible;" class="input-group-text">
          <i [ngClass]="{'zmdi-eye':isPasswordVisible, 'zmdi-eye-off':!isPasswordVisible}" class="zmdi"
            aria-hidden="true"></i>
        </a>
      </div>
      <div class="invalid-feedback" *ngIf="changePasswordFrom.controls['password'].hasError('required') && showError">
        *Please enter new password.
      </div>
      <div class="invalid-feedback"
        *ngIf="(changePasswordFrom.controls['password'].hasError('pattern') || changePasswordFrom.controls['password'].hasError('maxlength')) && showError">
        *Password must be 6 to 16 alphanumeric upper and lower case characters in length and contain at least one
        special character and one number value.
      </div>
    </div>
    <div class="form-group">
      <label>Confirm Password*</label>
      <div class="pwdWrap">
        <input [type]="isNewPasswordVisible ? 'text' : 'password'" class="form-control"
          placeholder="Confirm new password" formControlName="confirmPassword" name="confirmPassword">
        <a href="javascript:void(0)" (click)="isNewPasswordVisible = !isNewPasswordVisible;" class="input-group-text">
          <i [ngClass]="{'zmdi-eye':isNewPasswordVisible, 'zmdi-eye-off':!isNewPasswordVisible}" class="zmdi"
            aria-hidden="true"></i>
        </a>
      </div>
      <div class="invalid-feedback"
        *ngIf="changePasswordFrom.controls['confirmPassword'].hasError('required') && showError">
        *Please enter confirm password.
      </div>
      <div class="invalid-feedback"
        *ngIf="(changePasswordFrom.controls['confirmPassword'].hasError('confirmedValidator') || changePasswordFrom.controls['confirmPassword'].hasError('pattern')) && showError">
        *New Password does not match with confirm password.
      </div>
    </div>
    <button type="submit" class="btn btn-primary mt-2">Change Password</button>
  </form>
</div>